export const calcPercent = (a: number, b: number) => {
  return (a / b) * 100
}
